"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageTransforms = dataUtils.appendImageTransforms;

var ConfiguratorImage = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ConfiguratorImage, _React$Component);

  function ConfiguratorImage() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ConfiguratorImage.prototype;

  _proto.render = function render() {
    var vehicleImage = this.props.vehicleImage;
    var theme = this.props.theme || {};
    var imageWidth = 1600;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['col-xs-12'] + " " + theme['col-sm-4'] + " " + _configuratorSmallSummary["default"].info + " " + _configuratorSmallSummary["default"].productHolder
    }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
      className: _configuratorSmallSummary["default"].summaryImage,
      src: appendImageTransforms(handleNestedProp(vehicleImage, 'vehicleImage.image'), imageWidth),
      width: imageWidth,
      alt: handleNestedProp(vehicleImage, 'vehicleImage.altText')
    }));
  };

  return ConfiguratorImage;
}(_react["default"].Component);

exports["default"] = ConfiguratorImage;
ConfiguratorImage.displayName = 'Image';
ConfiguratorImage.defaultProps = {
  vehicleImage: null,
  theme: {}
};